var _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "cross-second",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.37,
    x2: 54.63,
    y1: 9.37,
    y2: 54.63,
    fill: "none",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.37,
    x2: 54.63,
    y1: 54.63,
    y2: 9.37,
    fill: "none",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossSecond);
export default __webpack_public_path__ + "static/media/cross_second.bc526538a20ebcd8d992e0f476b888d2.svg";
export { ForwardRef as ReactComponent };